 
import './App.css';
 
import './styles/style.css';
import 'bootstrap/dist/js/bootstrap.bundle'

import { useState, useEffect } from 'react' 
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import LoginScreen from './screens/LoginScreen';
import Home from './routes/Home';
import CarouselGenerator from './routes/carouselGenerator/CarouselGenerator';
import MediaLibrary from './routes/media-library/MediaLibrary';
import {
  BrowserRouter,
  Routes, Navigate,
  Route
} from "react-router-dom"; 

import WritePost from './routes/WritePost';
import HookGenerator from './routes/hookGenerator/HookGenerator'; 
import { AuthProvider } from "./AuthContext";
import PostGenerator from './routes/postGenerator/PostGenerator';
import RepurposeContent from './routes/repurposeContent/RepurposeContent';
import SearchPosts from './routes/searchPosts/SearchPosts';
import Billing from './routes/billing/Billing';
import Faq from './routes/faq/Faq';
import Settings from './routes/settings/Settings';
import CrmPage from './routes/crm/CrmPage';
import ScheduledPosts from './routes/scheduled/ScheduledPosts';
import PostedItems from './routes/posted-items/PostedItems';
import SocialAccounts from './routes/social-accounts/SocialAccounts';
import Team from './routes/team/Team';
import SinglePost from './routes/single-post/SinglePost';
import Calendar from './routes/calendar/Calendar';
import Failed from './routes/failed/Failed';
import Drafts from './routes/drafts/Drafts';
import LostPassword from './screens/LostPassword';
import ResetPassword from './screens/ResetPassword';
import Workspaces from './routes/workspaces/Workspaces';
import ApiAccess from './routes/api-access/ApiAccess';
import ContentCenter from './routes/content-center/ContentCenter';
import WritePinterestPost from './routes/WritePinterestPost';
import LinkedInCarouselPost from './routes/LinkedInCarouselPost';
import InstagramStoryPost from './routes/InstagramStoryPost';
import InstagramCarouselPost from './routes/InstagramCarouselPost';
import Analytics from './analytics/Analytics';
import TiktokPost from './routes/TikTokPost';
import BlueskyCallbackReturn from './components/general/BlueskyCallbackReturn';
import Publish from './routes/Publish';
import CalendarHome from './routes/CalendarHome';
import CreatorStudio from './routes/creator-studio/CreatorStudio';
import CarouselCreator from './routes/creator-studio/CarouselCreator';
import VideoEditor from './routes/creator-studio/VideoEditor';
import StitchedVideoEditor from './routes/creator-studio/StitchedVideoEditor';
import OnboardingFlow from './routes/onboarding/OnboardingFlow';
import ApprovalReview from './routes/approval/ApprovalReview';
import OAuthAuthorize from './routes/oauth/OAuthAuthorize';
import Affiliate from './routes/affiliate/Affiliate';
import { captureRefFromUrl } from './affiliate';

// Grab ?ref= off the landing URL before React Router can rewrite it, so an
// affiliate referral survives all the way to the registration call.
captureRefFromUrl();

function App() 
{ 
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null = loading

    useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await fetch('https://api.schedpilot.com/wp-json/api/v1/me', {
          method: 'GET',
          credentials: 'include', // includes the JWT cookie
        });

        if (res.ok) {
          const data = await res.json();
          if (data?.user_id) {
            setIsAuthenticated(true);
          } else {
            setIsAuthenticated(false);
          }
        } else {
          setIsAuthenticated(false);
        }
      } catch (err) {
        console.error('Auth check failed', err);
        setIsAuthenticated(false);
      }
    };

    checkAuth();
  }, []);
 

const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  return children;
};

// Like ProtectedRoute but redirects to /login?oauth_return=<current-url>
// so after login the user is returned to the OAuth consent page.
const OAuthRoute = ({ children }) => {
  if (!isAuthenticated) {
    const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
    return <Navigate to={`/login?oauth_return=${returnUrl}`} />;
  }
  return children;
};
 

if (isAuthenticated === null) {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
}
 
  return (   
 

    <AuthProvider>    
          <BrowserRouter>
    <Routes> 
              <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />              
              <Route path="hook-generator" element={<ProtectedRoute><HookGenerator /></ProtectedRoute>} />
              <Route path="schedule-posts" element={<ProtectedRoute><ScheduledPosts /></ProtectedRoute>} />
              <Route path="posted-items" element={<ProtectedRoute><PostedItems /></ProtectedRoute>} />
              <Route path="social-accounts" element={<ProtectedRoute><SocialAccounts /></ProtectedRoute>} />
              <Route path="team" element={<ProtectedRoute><Team /></ProtectedRoute>} />
              <Route path="calendar" element={<ProtectedRoute><Calendar /></ProtectedRoute>} />
              <Route path="failed" element={<ProtectedRoute><Failed /></ProtectedRoute>} />
              <Route path="drafts" element={<ProtectedRoute><Drafts /></ProtectedRoute>} />
              <Route path="single-post/:postId" element={<ProtectedRoute><SinglePost /></ProtectedRoute>} />
              <Route path="hook-generator" element={<ProtectedRoute><HookGenerator /></ProtectedRoute>} />
              <Route path="post-generator" element={<ProtectedRoute><PostGenerator /></ProtectedRoute>} />
              <Route path="carousel-generator" element={<ProtectedRoute><CarouselGenerator /></ProtectedRoute>} />
              <Route path="search-posts" element={<ProtectedRoute><SearchPosts /></ProtectedRoute>} />
              <Route path="repurpose-content" element={<ProtectedRoute><RepurposeContent /></ProtectedRoute>} />
              <Route path="content-center" element={<ProtectedRoute><ContentCenter /></ProtectedRoute>} />
              <Route path="editor-choice" element={<ProtectedRoute><HookGenerator /></ProtectedRoute>} />


              <Route path="publish" element={<ProtectedRoute><Publish /></ProtectedRoute>} />
              <Route path="calendar-home" element={<ProtectedRoute><CalendarHome /></ProtectedRoute>} />
              <Route path="creator-studio" element={<ProtectedRoute><CreatorStudio /></ProtectedRoute>} />
              <Route path="creator-studio/carousel" element={<ProtectedRoute><CarouselCreator /></ProtectedRoute>} />
              <Route path="creator-studio/video" element={<ProtectedRoute><VideoEditor /></ProtectedRoute>} />
              <Route path="creator-studio/stitched-video" element={<ProtectedRoute><StitchedVideoEditor /></ProtectedRoute>} />


              <Route path="billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
              <Route path="faq" element={<ProtectedRoute><Faq /></ProtectedRoute>} />
              <Route path="settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
              <Route path="crm" element={<ProtectedRoute><CrmPage /></ProtectedRoute>} /> 
              <Route path="write-post" element={<ProtectedRoute><WritePost /></ProtectedRoute>} />  
              <Route path="post-pinterest" element={<ProtectedRoute><WritePinterestPost /></ProtectedRoute>} />
              <Route path="post-linkedin-carousel" element={<ProtectedRoute><LinkedInCarouselPost /></ProtectedRoute>} />
              <Route path="post-instagram-story" element={<ProtectedRoute><InstagramStoryPost /></ProtectedRoute>} />
              <Route path="post-instagram-carousel" element={<ProtectedRoute><InstagramCarouselPost /></ProtectedRoute>} />
              <Route path="post-tiktok" element={<ProtectedRoute><TiktokPost /></ProtectedRoute>} />    
              <Route path="bluesky-callback-return" element={<ProtectedRoute><BlueskyCallbackReturn /></ProtectedRoute>} />    

              
              
              <Route path="media-library" element={<ProtectedRoute><MediaLibrary /></ProtectedRoute>} />   
              <Route path="analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />     
              <Route path="workspaces" element={<ProtectedRoute><Workspaces /></ProtectedRoute>} />          
              <Route path="api-access" element={<ProtectedRoute><ApiAccess /></ProtectedRoute>} />
              <Route path="affiliate" element={<ProtectedRoute><Affiliate /></ProtectedRoute>} />

              {/* OAuth consent page — NOT wrapped in ProtectedRoute; OAuthRoute
                  handles the redirect to /login?oauth_return=... so after login
                  the user lands back here instead of the dashboard. */}
              <Route path="/oauth/authorize" element={<OAuthRoute><OAuthAuthorize /></OAuthRoute>} />

              <Route path="/login" element={<LoginScreen />} />
              <Route path="/forgot-password" element={<LostPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/onboarding-flow" element={<OnboardingFlow />} />
              <Route path="/review/:token" element={<ApprovalReview />} />

              <Route path="*" element={<Navigate to="/" replace />} />

   </Routes>  

   </BrowserRouter> 
 <ToastContainer
        position="top-center" // 👈 sets to top center
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
   </AuthProvider>


    
  );
}

export default App;

 